





import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';

class RowNumberRenderer {
  private el: any;
  constructor(props) {
    const el = document.createElement('div');
    el.style.marginLeft = '10px';
    el.innerHTML = this.render(props);
    this.el = el;
  }

  getElement() {
    return this.el;
  }

  render(props: any) {
    const {value, formattedValue, grid, rowKey} = props;
    const displayOrderStr = formattedValue.padStart(2, '0');
    const lastRowKey = grid.getRowCount();

    return `<div class="location_control small">
    <span class="controlBtn actionBtn ${value === 1 ? 'disabled' : ''}" data-action="orderChange" data-rowkey="${rowKey}" data-type="up">▲</span>
    <span class="controlBtn actionBtn ${value === lastRowKey ? 'disabled' : ''}" data-action="orderChange" data-rowkey="${rowKey}" data-type="down">▼</span>
    </div>
    <span class="displayOrder order" style="font-size: 11px;">${displayOrderStr}</span>`;
  }
}

@Component
export default class ProductPriorityGrid extends Vue {
  @Prop({required: true})
  private readonly gridProps!: any;

  @Prop({required: true, default: () => []})
  private readonly data!: [];

  private options = {
    rowHeaders: [
      'checkbox',
      {
        type: 'rowNum',
        header: this.$t('PRODUCT_PRIORITY_ORDER'),
        align: 'center',
        width: 75,
        renderer: {
          type: RowNumberRenderer
        }
      }
    ],
    header: {
      height: 33
    },
    bodyHeight: 480,
    rowHeight: 28,
    minRowHeight: 28,
    useClientSort: false,
    heightResizable: true,
    isInitialRequest: true,
    id: 'product_priority_grid',
    columnOptions: {
      minWidth: 50,
      resizable: true,
      frozenCount: 0
    },
    noPagination: true
  };

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('setBodyHeight', this.data.length === 0 ? 190 : this.options.bodyHeight);
    grid.invoke('resetData', this.data as any);
  }

  private onCheck({rowKey, instance}: any) {
    setTimeout((): void => {
      instance.addRowClassName(rowKey, 'product-item-checked');
    }, 100);
  }

  private onUnCheck({rowKey, instance}: any) {
    setTimeout((): void => {
      instance.removeRowClassName(rowKey, 'product-item-checked');
    }, 100);
  }
}
